import { IonAccordion, IonAccordionGroup, IonAvatar, IonBackButton, IonButton, IonButtons, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonCol, IonContent, IonFab, IonFabButton, IonGrid, IonHeader, IonIcon, IonImg, IonItem, IonLabel, IonMenuButton, IonPage, IonRefresher, IonRefresherContent, IonRow, IonSkeletonText, IonSpinner, IonTitle, IonToolbar, RefresherEventDetail, useIonRouter, useIonViewDidEnter, useIonViewWillEnter } from '@ionic/react';
import { add, addCircleOutline, informationCircle, navigateOutline, pawOutline } from 'ionicons/icons';
import React, { useEffect, useState } from 'react';
import InitialsAvatar from 'react-initials-avatar';
import 'react-initials-avatar/lib/ReactInitialsAvatar.css';
import { Link } from 'react-router-dom';
import { useAppContext } from '../AppProvider';
import { Alert, AlertTitle } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const Pets: React.FC = () => {
    const [loading, setLoading] = useState<boolean>(true);
    const [alertVisible, setAlertVisible] = useState<boolean>(false);
    const router = useIonRouter();

    const { networkStatus, getAppStatus, authKey, authenticateMember, authorizedMember, setShowLoader, level, settings, profiles, limits, pets, getPets, textLogoLoaded, fadeInTextLogo, SWTextLogo, SWFullHorizLogo, SWTextDarkLogo } = useAppContext();
    
    const petPhotoPath = '//api.besolowise.com/pets/photos/files/'; 

    //
    // Authenticate Member
    //
    useIonViewWillEnter(() => { 
        setShowLoader(true);
        const authenticate = async () => {
            const appstat = await getAppStatus();
            if (!networkStatus && appstat === 'No') {
                router.push('/connection', 'forward');
            } else {
                const authenticated = await authenticateMember();         
                if(!authenticated || authenticated.mt == '') router.push('/login', 'forward');
            }
        };
        authenticate();
    }); 


    useEffect(() => {
        if (limits.pets > 0) {
            const fetchData = async () => {
                await getPets(authorizedMember.memberToken, limits.pets);
                window.setTimeout(() => {
                    setShowLoader(false);
                }, 2000);
            }
            fetchData();
        }
    }, [authorizedMember, limits]);


    const handleRefresh = (event: CustomEvent<RefresherEventDetail>) => {
        //setLoading(true);
        setTimeout(async () => {
            await getPets(authKey.mt, limits.pets);
            event.detail.complete();
            //setLoading(false);
        }, 2000);
    };

    const toggleAlertContent = () => setAlertVisible(!alertVisible);

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot='start'>
                        <IonBackButton color={'tertiary'}>Back</IonBackButton>
                    </IonButtons>
                    <IonTitle><IonImg className={textLogoLoaded ? 'fade-in' : 'fade-out'} src={settings.theme == '1' ? SWTextDarkLogo : SWFullHorizLogo} onIonImgDidLoad={fadeInTextLogo}></IonImg></IonTitle>
                    <IonButtons slot='end'>
                        <IonMenuButton color={'tertiary'} />
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding account-content-bg" id="Pets">

                <IonRefresher slot="fixed" onIonRefresh={handleRefresh}>
                    <IonRefresherContent></IonRefresherContent>
                </IonRefresher>

                <IonGrid>
                    <IonRow>
                        <IonCol size='12' sizeSm='7'>
                            <h1><IonIcon color={'secondary'} icon={pawOutline}></IonIcon> My Pets<br /><span>Manage your saved Pets</span></h1>
                        </IonCol>
                        <IonCol className='ion-margin-bottom top-action-button'  size='12' sizeSm='5'>                            
                            {level?.memberLevelID >= 2 && profiles.pets < limits.pets &&
                                <IonButton className='ion-margin' color={'secondary'} routerLink='/account/pet/create' routerDirection='forward'><IonIcon icon={addCircleOutline} slot='start'></IonIcon> Add a New Pet</IonButton>
                            }
                        </IonCol>
                    </IonRow>
                </IonGrid>      

                <IonAccordionGroup className='ion-margin'>
                    <IonAccordion value="info">
                        <IonItem slot='header' color={'light'}>
                            <IonLabel><IonIcon color={'tertiary'} icon={informationCircle} size='large'></IonIcon> What is a SoloWise Pet?</IonLabel>
                        </IonItem>
                        <div slot="content">                
                            <IonCard>
                                <IonCardContent>
                                    <p>A <strong>SoloWise Pet</strong> can be any animal that accompanies you during your Timers.</p>
                                </IonCardContent>
                            </IonCard>
                        </div>
                    </IonAccordion>
                </IonAccordionGroup>    
                
                {pets.length > 0
                    ? (pets.map((pet:any, index:number) => (                    
                        <IonCard key={index} routerDirection='forward' routerLink={`/account/pet/edit/${pet.petToken}`}>
                            <IonCardHeader className='kid-header'>
                                {pet.petPhoto == ''
                                    ? (<InitialsAvatar className='initials-avatar' name={`${pet.petName}`} />)  
                                    : (<IonAvatar className='inline-thumbnail'><IonImg src={pet.petPhotoThumbnailUrl} /></IonAvatar>)
                                } 
                                <div className='inline-name ion-margin-start'>
                                    <IonCardTitle>{pet.petName}</IonCardTitle>
                                    <IonCardSubtitle>{pet.petBreed}</IonCardSubtitle>
                                </div>
                            </IonCardHeader>
                        </IonCard>                    
                      )))
                    : <p className='ion-text-center'>You have no recorded SoloWise Pets.</p>
                }

            </IonContent>
        </IonPage>
    );
};

export default Pets;